import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { MdArrowForward } from "react-icons/md";

export default function CallToAction() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <section className="sleek-fullwidth-ribbon-cta">
      <div className="container-fluid px-4 px-md-5">
        <div className="ribbon-flex-alignment-layer">
          
          {/* Left Text Alignment Column Group */}
          <div className="ribbon-message-package">
            <div className="ribbon-vertical-gold-pillar" />
            <p className="ribbon-main-prompt-text">
              Ready to maximize your enterprise fiscal stability?{" "}
              <span className="ribbon-subtext-muted">
                Connect with our senior executive advisory team for a detailed compliance consultation.
              </span>
            </p>
          </div>

          {/* Right Action Button Group */}
          <div className="ribbon-action-package">
            <button 
              className="ribbon-minimalist-action-btn" 
              onClick={() => appContext.navTo({ item: "contact" })}
            >
              <span>Schedule Consultation</span>
              <MdArrowForward className="ribbon-arrow-transition-node" />
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}